import React from "react";
import Image from "next/image";
import handframe from "./handframe.png";

const SpominskaStran = () => {
  return (
    <section className="w-full flex flex-row justify-center bg-[#083545] py-16 px-5">
      <div className="mx-auto max-w-[1240px] flex flex-col desktop:flex-row items-center desktop:gap-10 gap-2">
        <div className="hidden desktop:block w-[320px] flex-shrink-0">
          <Image
            src={handframe}
            alt="spominska stran"
            className="w-full h-auto rounded-sm object-cover desktop:mt-[60px]"
          />
        </div>

        {/* Text Content */}
        <div className="w-full tablet:max-w-[672px] desktop:max-w-[600px] desktop:flex-1 flex flex-col desktop:text-left items-center desktop:items-start tablet:px-[20px] desktop:px-0">
          {/* Heading */}
          <h2 className="mobile:text-[26px] text-[40px] font-normal text-white mb-6">
            Spominska stran brezplačno
          </h2>

          {/* Description */}
          <div className="text-white/80 text-[16px] mobile:max-w-[310px] leading-relaxed space-y-6">
            <p>
              Najbližji ne izginejo. Ostanejo v zgodbah in dragocenih spominih,
              ki jih nosimo naprej.
            </p>
            <p className="tablet:mt-8">
              Spominska omogoča, da spomini ne zbledijo. Namesto hladne
              osmrtnice, na katero se nikoli ne vrnemo, ustvarja topel prostor
              povezanosti vseh bližnjih – prostor, kamor se vračamo, ko želimo
              znova začutiti bližino in ohraniti vezi.{" "}
              <span className="mobile:block mobile:mt-6">
                Ker se stran nenehno dopolnjuje, spomini z vsakim novim zapisom
                znova oživijo ter krepijo družinske vezi.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpominskaStran;
